// import FullScreenLoader from "components/Dashboard/FullScreenLoader"
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useQuery } from "react-query";
import { getRefferedLoans, reviewLoanByLPH } from "services/LoanService";
import FilterComp from "../FilterComp";
import { APPCOLUMNS_V3, APPCOLUMNS_V4, getAppColumns } from "./appColumns";
import SendMemoComp from "../SendMemoComp";
import { observer } from "mobx-react-lite";
import CheckboxAll from "components/Checkbox/checkAll";
import LoanFilter from "components/Dashboard/LoanFIlter";
import { Table } from "antd";
import ConfirmAccept from "./ConfirmAccept";
import { useSearchParams } from "react-router-dom";
import { usePaginate } from "hooks/usePagination";
import SuperUserService from "components/superuser/SuperUserService";
import SendAllToMemo from "../SendAllToMemo";
import { CheckBox } from "components/Checkbox";

function FilterHeader({
  admin_role,
  handleLoanFilter,
  handleFilter,
  filter,
  loanFilter,
  globalFilter,
  setGlobalFilter,
  is_accepted = false,
}) {
  const filterOptions = [
    { value: "all", label: "All Loans" },
    { value: "viewed", label: "Viewed Loans" },
    { value: "unviewed", label: "Unviewed Loans" },
    // { value: "accepted", label: "Accepted Loans", },
  ];
  return (
    <div className="flex items-center justify-between gap-8 my-2">
      {!is_accepted && (admin_role === "lph" || admin_role === "la") && (
        <div className="flex flex-[2] items-center gap-2">
          <button
            onClick={() => handleLoanFilter("all")}
            className={`py-1 px-4 min-w-[100px] rounded-md ${loanFilter === "all" ? "bg-primary text-white" : "bg-gray-200 border border-solid border-gray-400"}`}
          >
            All
          </button>
          <button
            onClick={() => handleLoanFilter("edit")}
            className={`py-1 px-4 rounded-md ${loanFilter === "edit" ? "bg-primary text-white" : "bg-gray-200 border border-solid border-gray-400"}`}
          >
            Edit Requested
          </button>
          <LoanFilter
            options={filterOptions}
            filter={filter}
            handleFilter={handleFilter}
          />
        </div>
      )}
      <div className="flex-1">
        <FilterComp filter={globalFilter} setFilter={setGlobalFilter} />
      </div>
    </div>
  );
}

const RefferedLoansComp = ({ admin_role, user, is_accepted = false }) => {
  const { setPage, page, limit, setLimit } = usePaginate({ defaultLimit: 10 });
  const [params, setParams] = useSearchParams();
  const [searchQuery, updateSearchQuery] = useState("");
  const [filter, setFilter] = useState("all");
  const [selectedLoans, setSelectedLoans] = useState([]);
  const [loanFilter, setLoanFilter] = useState(
    is_accepted ? "accepted" : "all",
  );


  const toggleSelectedLoan = (loan) => {
    setSelectedLoans(prev => {
      const existingLoan = prev.find(item => item._id === loan._id)
      
      if (existingLoan) return prev.filter(item => item._id !== loan._id)
      return [...prev,loan]

    })
  }

  const selectedLoanIds = useMemo(
    () => selectedLoans.map((item) => item._id),
    [selectedLoans],
  );

  const queryParams = useMemo(() => {
    return {
      page,
      limit,
      search: searchQuery || undefined,
      status: is_accepted ? "accepted" : filter !== "all" ? filter : undefined,
      edit_requested: loanFilter === "edit" ? true : undefined,
    };
  }, [page, limit, filter, searchQuery, loanFilter, is_accepted]);

  const {
    data: referredLoansResponse,
    isLoading,
    refetch,
  } = useQuery(["approved-loans", queryParams], () =>
    getRefferedLoans(queryParams),
  );

  const setSearchQuery = (queryString) => {
    updateSearchQuery(queryString);
    setPage(1);
    setLimit(10);
  };

  const [, setEsLoans] = useState([]);
  const [loading, setLoading] = useState(true);
  const total = useMemo(
    () => referredLoansResponse?.data?.total ?? 0,
    [referredLoansResponse],
  );
  const totalLoanAmount = useMemo(
    () => referredLoansResponse?.data?.total_loan_amount ?? 0,
    [referredLoansResponse],
  );
  const totalESAmount = useMemo(
    () => referredLoansResponse?.data?.total_es_amount ?? 0,
    [referredLoansResponse],
  );
  useEffect(() => {
    const getLoans = async () => {
      const [data] = await SuperUserService.getLoans();
      setLoading(false);
      if (data) {
        setEsLoans(data?.data);
      }
    };
    getLoans();
  }, []);

  const filterData = (arrData) => {
    return arrData;
    // 	.filter((loan)=>{
    // 	if(!loan) return true;
    // 	const queryString = `${loan.applicant.first_name} ${loan.applicant.surname}`.toLowerCase()
    // 	return queryString.includes(searchQuery.toLowerCase())
    // })
  };

  const handleSetParams = (_filter, _loanFilter) => {
    setParams({
      filter: _filter,
      loan_filter: _loanFilter,
    });
  };

  const handleFiilter = (_filter) => {
    // setFilter(_filter)
    handleSetParams(_filter, loanFilter);
  };
  const handleLoanFiilter = (_loanFilter) => {
    // setLoanFilter(filter)
    handleSetParams(filter, _loanFilter);
  };

  useEffect(() => {
    if (params) {
      const _filter = params.get("filter");
      const _loanFilter = params.get("loan_filter");
      setFilter(_filter || filter);
      setLoanFilter(_loanFilter || loanFilter);
    }
  }, [params, loanFilter, filter]);

  const columns = useMemo(() => {
    if (admin_role !== "lph") {
      return [
        ...APPCOLUMNS_V4,
        {
          title: "Action",
          key: "details",
          fixed: "right",
          width: 100,
          render: (_, originalRow) => (
            <ConfirmAccept
              actionHandler={() => reviewLoanByLPH(originalRow.id)}
              refetch={refetch}
            />
          ),
        },
      ];
    }

    if (loanFilter === "edit") {
      return [
        ...APPCOLUMNS_V3,
        {
          title: "Action",
          key: "details",
          fixed: "right",
          width: 100,
          render: (_, originalRow) => (
            <ConfirmAccept
              actionHandler={() => reviewLoanByLPH(originalRow.id)}
              refetch={refetch}
            />
          ),
        },
      ];
    }

    return [
      {
        title: "Pick",
        fixed: "left",
        key: "pick",
        width: 100,
        render: (_, originalRow) => (
          <CheckBox
            checked={selectedLoanIds.includes(originalRow._id)}
            handleCheck={() => {
              toggleSelectedLoan(originalRow)
            } }
            
          
          />
        ),
      },

      ...APPCOLUMNS_V4,
      {
        title: "Action",
        key: "details",
        fixed: "right",
        width: 100,
        render: (_, originalRow) => (
          <ConfirmAccept
            actionHandler={() => reviewLoanByLPH(originalRow.id)}
            refetch={refetch}
          />
        ),
      },
    ];
  }, [admin_role, loanFilter, refetch,selectedLoanIds]);

  const data = useMemo(() => {
    const referredLoans = referredLoansResponse?.data?.loans;
    if (!referredLoans) return [];
    return referredLoans;
  }, [referredLoansResponse?.data?.loans]);

  const referredLoanIds = useMemo(() => {
    return data.map(item=>item._id)
  },[data])


  const isAllLoanSelected = useMemo(() => {
    if (selectedLoans.length === 0) return false;

    return referredLoanIds.every((id) => selectedLoanIds.includes(id))

  }, [referredLoanIds, selectedLoans, selectedLoanIds]);

  const pagination = useMemo(() => {
    return {
      nextPageUrl: null,
      offset: 0,
      limit: 10,
      total: referredLoansResponse?.data?.total ?? 10,
      page: 1,
      prevPage: null,
      prevPageUrl: null,
      nextPage: null,
      totalPages: 1,
      ...referredLoansResponse?.data?.pagination,
    };
  }, [referredLoansResponse]);

  const getLoanStats = useCallback(() => {
    const allLoans = data.map((loan) => loan.amount);
    const totalAmount =
      allLoans.length > 0 ? allLoans.reduce((a, b) => a + b, 0) : 0;

    return {
      total,
      totalAmount,
    };
  }, [data, total]);

  return (
    <>
      <div>
        <FilterHeader
          loanFilter={loanFilter}
          filter={filter}
          is_accepted={is_accepted}
          handleFilter={handleFiilter}
          handleLoanFilter={handleLoanFiilter}
          admin_role={admin_role}
          globalFilter={searchQuery}
          setGlobalFilter={setSearchQuery}
        />
        {(admin_role === "lph" || admin_role === "la") && (
          <div className="flex items-center justify-between gap-2 my-4">
            {admin_role === "lph" && (
              <CheckBox
                checked={isAllLoanSelected}
                handleCheck={() => {
                if (isAllLoanSelected) {
                  setSelectedLoans((prev) =>
                    prev.filter((loan) => !referredLoanIds.includes(loan._id)),
                  );
                  return;
                }

                setSelectedLoans((prev) => {
                  const existingIds = new Set(prev.map((loan) => loan._id));

                  const newLoans = data.filter(
                    (loan) => !existingIds.has(loan._id),
                  );

                  return [...prev, ...newLoans];
                });
                }}
              label={"Select All"}
              />
            )}
            {admin_role === "lph" && (
              <div className="flex items-center gap-x-4">
                <SendAllToMemo
                  total={total}
                  queryParams={queryParams}
                  title={`Send All to Memo (${total})`}
                  user={user}
                  totalAmount={totalLoanAmount}
                />
                <SendMemoComp
                  totalESAmount={totalESAmount}
                  selectedLoans={selectedLoans}
                  title={`Send Selected to Memo`}
                  user={user}
                />
              </div>
            )}
          </div>
        )}

        <div className="">
          <Table
            loading={isLoading || loading}
            columns={columns}
            pagination={{
              total: pagination.total,
              current: pagination.page,
              onShowSizeChange: (_, size) => {
                setLimit(size);
              },
              onChange: (pageNumber) => {
                setPage(pageNumber);
              },
              pageSize: limit,
              nextIcon: () => {
                const next = () =>
                  pagination.nextPage
                    ? setPage(pagination.nextPage)
                    : undefined;
                return (
                  <button onClick={next}>
                    {" "}
                    <i className="bi bi-chevron-right"></i>
                  </button>
                );
              },
              prevIcon: () => {
                const prev = () =>
                  pagination.prevPage
                    ? setPage(pagination.prevPage)
                    : undefined;

                return (
                  <button onClick={prev}>
                    {" "}
                    <i className="bi bi-chevron-left"></i>
                  </button>
                );
              },
            }}
            dataSource={filterData(data)}
            scroll={{ x: "max-content" }}
            footer={() => {
              const { total } = getLoanStats();
              return (
                <div className="flex items-center">
                  <p>
                    <span className="font-medium">Total Loan</span> :{total}
                  </p>
                </div>
              );

              // return (
              //   <div className="flex items-center justify-between">
              //     <p>
              //       <span className="font-medium">Total Loan Amount</span> : ₦
              //       {totalAmount.toLocaleString()}
              //     </p>
              //     <p>
              //       <span className="font-medium">Total Loan</span> :{total}
              //     </p>
              //   </div>
              // );
            }}
          />
        </div>
      </div>
    </>
  );
};

export default observer(RefferedLoansComp);
